<!-- HomeCalculator.vue -->
<template>
  <div class="home-calculator"
    :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
    <div class="calculator-container">
      <div class="calculator-header">
        <div class="header-title">Calculators</div>
        <div class="header-desc">Calculate your auto loan, lease, and total ownership costs
          effortlessly with our comprehensive car calculators.</div>
        <div class="header-divider"></div>
      </div>
    </div>

    <div class="calculator-cards">
      <a class="calculator-card-item" :href="getPageUrl('/auto-loan-calculator')">
        <div class="card-content blue-gradient">
          <div class="card-title">Auto loan calculator</div>
          <div class="card-image">
            <img src="@/assets/calculator-banner-1.png" alt="Auto loan calculator" />
          </div>
        </div>
        <div class="card-button white-button">
          <div class="button-text">Try it</div>
          <svg class="button-arrow" viewBox="0 0 16 12" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
              fill="#1A4048" />
          </svg>
        </div>
      </a>
      <a class="calculator-card-item" :href="getPageUrl('/auto-lease-calculator')">
        <div class="card-content green-gradient">
          <div class="card-title">Auto lease calculator</div>
          <div class="card-image">
            <img src="@/assets/calculator-banner-2.png" alt="Auto lease calculator" />
          </div>
        </div>
        <div class="card-button white-button">
          <div class="button-text">Try it</div>
          <svg class="button-arrow" viewBox="0 0 16 12" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
              fill="#1A4048" />
          </svg>
        </div>
      </a>

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_3" ref="ads-home-3"
        class="ad-width-100 " :ads="adsensConfig?.home_3" :showDebug="showDebug" />

      <a class="calculator-card-item" :href="getPageUrl('/total-car-cost-calculator')">
        <div class="card-content yellow-gradient">
          <div class="card-title">Total car cost calculator</div>
          <div class="card-image">
            <img src="@/assets/calculator-banner-3.png" alt="Total car cost calculator" />
          </div>
        </div>
        <div class="card-button white-button">
          <div class="button-text">Try it</div>
          <svg class="button-arrow" viewBox="0 0 16 12" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
              fill="#1A4048" />
          </svg>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'
export default {
  name: 'HomeCalculator',
  components: {
    AdComponent
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'adsensConfig',
      'showDebug'
    ])
  },
  methods: {
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`
      }
      return path
    },
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.home-calculator {
	padding: 0px rem(120) 0px rem(120);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;

	&.detect_deviece_mobile {
		padding: 0;
		gap: rem(36);
	}

	.calculator-container {
		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 100%);
		border-radius: rem(24);
		padding: rem(52) 0px rem(136) 0px;
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.detect_deviece_mobile & {
			padding: rem(30) 0 rem(100) 0;
			gap: rem(20);
		}
	}

	.calculator-header {
		padding: 0px rem(120) 0px rem(120);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.detect_deviece_mobile & {
			padding: 0 rem(20);
		}
	}

	.header-title {
		color: #1a4048;
		text-align: center;
		font-size: rem(32);
		line-height: rem(32);
		font-weight: 900;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
		}
	}

	.header-desc {
		color: #1a4048;
		text-align: center;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
		position: relative;

		.detect_deviece_mobile & {
			font-size: rem(14);
			line-height: rem(18);
		}
	}

	.header-divider {
		background: var(--theme-primary);
		border-radius: rem(100);
		flex-shrink: 0;
		width: rem(36);
		height: rem(4);
		position: relative;
	}

	.calculator-cards {
		margin: rem(-100) 0 0 0;
		padding: 0px rem(60) 0px rem(60);
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.detect_deviece_mobile & {
			flex-direction: column;
			gap: rem(40);
			align-items: center;
			padding: 0 rem(20);
		}
	}

	.calculator-card-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		transition: transform 0.3s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(rem(-10));

			.card-button {
				&.white-button {
					background: #1a4048;

					.button-text {
						color: #ffffff;
					}

					.button-arrow {
						path {
							fill: #ffffff;
						}
					}
				}
			}
		}
		.detect_deviece_mobile & {
			width: 100%;
		}
	}

	.card-content {
		border-radius: rem(20);
		padding: rem(20) rem(19) rem(28) rem(19);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		width: rem(340);
		position: relative;

		&.blue-gradient {
			background: linear-gradient(180deg, #2775e9 0%, #5594f3 100%);
		}

		&.green-gradient {
			background: linear-gradient(180deg, rgba(25, 196, 165, 1) 0%, rgba(111, 231, 209, 1) 100%);
		}

		&.yellow-gradient {
			background: linear-gradient(180deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
		}

		.detect_deviece_mobile & {
			width: 100%;
		}
	}

	.card-title {
		color: #ffffff;
		text-align: center;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;

		.detect_deviece_mobile & {
			font-size: rem(20);
			line-height: rem(22);
		}
	}

	.card-image {
		flex-shrink: 0;
		width: rem(300);
		height: rem(160);
		position: relative;
		overflow: visible;

		.detect_deviece_mobile & {
			width: 100%;
			height: auto;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: rem(10);
		}
	}

	.card-button {
		margin: rem(-20) 0 0 0;
		border-radius: rem(100);
		border-style: solid;
		border-color: #1a4048;
		border-width: rem(1);
		padding: rem(12) rem(32) rem(12) rem(32);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: rem(136);
		height: rem(40);
		position: relative;
		transition: all 0.3s ease;

		&.white-button {
			background: #ffffff;

			.button-text {
				color: #1a4048;
			}
		}

		&.dark-button {
			background: #1a4048;

			.button-text {
				color: #ffffff;
			}
		}
	}

	.button-text {
		text-align: center;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
	}

	.button-arrow {
		flex-shrink: 0;
		width: rem(16);
		height: rem(12);
	}

	&__more-btn {
		background: var(--theme-primary);
		border-radius: rem(8);
		flex-shrink: 0;
		width: rem(40);
		height: rem(40);
		position: relative;
		overflow: visible;
		transition: all 0.3s ease;
	}
}
</style> 